import { NgModule } from '@angular/core';

import {
  FiltersService,
  OrderDetailsService,
  OrdersService,
  OrdersV2Service,
} from './services';

@NgModule({
  providers: [
    FiltersService,
    OrdersService,
    OrderDetailsService,
    OrdersV2Service,
  ],
})
export class DataOrderBookModule {}
